module.exports = __webpack_public_path__ + "static/media/elitePlatinum.ea33bc8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elitePlatinum.svg
// module id = 6622
// module chunks = 0